import React from 'react';
import { GlobalLink } from '@hpstellar/core';
import { formatGtmAction } from '@hpstellar/utils';
import { RadioCard, Tooltip as TooltipVisid } from '@hpstellar/core/visId';

import ConditionalWrapper from '../../../../../shared/components/conditional-wrapper';
import useTemplateTheme from '../../../../../hooks/useTemplateTheme';
import { Helpers } from '../../../../../core/src/helpers';

import './radio-option-group.less';

export default ({
    label,
    checked,
    isUnavailable,
    unavalableTooltip,
    href,
    gtmAttributes,
    useRelativePath = true,
    disabled,
    onRadioClick,
    className,
    groupName,
    tooltipTitle = 'Not available with this configuration',
    tooltipClassName
}) => {
    const { css } = useTemplateTheme();

    return (
        <ConditionalWrapper
            condition={isUnavailable && unavalableTooltip}
            wrapper={children => (
                <TooltipVisid
                    key={label}
                    activeOnHover
                    content={unavalableTooltip.description}
                    position="top-start"
                    title={tooltipTitle}
                    tooltipClassName={tooltipClassName}
                >
                    <div className="radio-tooltip-wrapper">{children}</div>
                </TooltipVisid>
            )}
        >
            <ConditionalWrapper
                condition={!!href}
                wrapper={children => (
                    <GlobalLink
                        className={`radio-option-link${className ? ` ${className}` : ''}`}
                        onClick={() => {
                            onRadioClick();
                        }}
                        to={useRelativePath ? Helpers.getRelativePath(href) : href}
                        {...(gtmAttributes || {})}
                    >
                        {children}
                    </GlobalLink>
                )}
            >
                <RadioCard
                    className={`radio-container${css ? ` ${css}-radio` : ''}`}
                    inputProps={{
                        checked,
                        name: groupName,
                        'aria-label': label,
                        value: label,
                        disabled,
                        ...formatGtmAction(gtmAttributes, 'radioClick'),
                        readOnly: true,
                    }}
                    outlineClassName={`outline-container${isUnavailable ? ' not-compatible' : checked ? ' radio-active' : ''}`}
                >
                    <div className="radioLabelText">{label}</div>
                </RadioCard>
            </ConditionalWrapper>
        </ConditionalWrapper>
    );
};
